import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  "data-type": "vue-product",
  class: "tw-flex tw-flex-wrap tw-flex-row tw-h-full tw-relative",
  "data-product-card": ""
}
const _hoisted_2 = { class: "tw-w-full" }
const _hoisted_3 = { class: "tw-w-full ratio-1-1 tw-relative tw-mb-xs" }
const _hoisted_4 = ["href", "aria-label"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "tw-w-full tw-mb-md" }
const _hoisted_7 = { class: "h6 tw-uppercase" }
const _hoisted_8 = ["href", "aria-label"]
const _hoisted_9 = { class: "tw-font-soehne-buch tw-leading-5 tw-font-black" }
const _hoisted_10 = {
  key: 0,
  class: "tw-w-full tw-my-xs"
}
const _hoisted_11 = { class: "tw-text-base" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "tw-my-xs tw-bg-black" }, null, -1 /* HOISTED */)
const _hoisted_13 = {
  key: 0,
  class: "metafield-list tw-w-full tw-mt-xs tw-grid tw-grid-cols-1 tw-gap-xs"
}
const _hoisted_14 = {
  key: 0,
  class: "metafield-list__item tw-flex tw-flex-row tw-flex-wrap tw-items-start tw-w-full"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "metafield-list__item-key tw-block tw-w-full" }, " Flavour profile ", -1 /* HOISTED */)
const _hoisted_16 = { class: "metafield-list__item-value tw-w-auto tw-block" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "metafield-list__item tw-flex tw-flex-row tw-flex-wrap tw-items-start tw-w-full"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "metafield-list__item-key tw-block tw-w-full" }, " Process ", -1 /* HOISTED */)
const _hoisted_20 = { class: "metafield-list__item-value tw-w-full tw-block" }
const _hoisted_21 = {
  key: 2,
  class: "metafield-list__item tw-flex tw-flex-row tw-flex-wrap tw-items-start tw-w-full"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "metafield-list__item-key tw-block tw-w-full" }, " Varietal ", -1 /* HOISTED */)
const _hoisted_23 = { class: "metafield-list__item-value tw-w-full tw-block" }
const _hoisted_24 = { class: "tw-w-full tw-grid sm:tw-grid-cols-2 tw-gap-xs tw-self-end tw-mt-15" }
const _hoisted_25 = ["aria-label"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Quick Add ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-md tw-ml-auto",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m16.312 9.76-1.008.992 3.072 3.36H9.24v1.44h9.136l-3.072 3.36 1.008.992 4.592-5.072-4.592-5.072Z",
    fill: "inherit"
  })
], -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = ["href", "aria-label"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" More info ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-md tw-ml-auto",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m16.312 9.76-1.008.992 3.072 3.36H9.24v1.44h9.136l-3.072 3.36 1.008.992 4.592-5.072-4.592-5.072Z",
    fill: "inherit"
  })
], -1 /* HOISTED */)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "tw-w-full tw-flex tw-flex-wrap tw-flex-auto tw-items-center tw-justify-between tw-gap-xs" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "tw-leading-4 tw-mb-xs" }, "Quick add", -1 /* HOISTED */)
const _hoisted_35 = {
  key: 0,
  class: "tw-w-full tw-grid md:tw-grid-cols-2 tw-gap-xs"
}
const _hoisted_36 = ["for"]
const _hoisted_37 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "tw-w-full tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-1 xxl:tw-grid-cols-2 tw-gap-x-xs tw-mt-xs" }
const _hoisted_40 = { class: "tw-w-full tw-mb-xs" }
const _hoisted_41 = ["for"]
const _hoisted_42 = ["id"]
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">1</option><option value=\"2\">2</option><option value=\"3\">3</option><option value=\"4\">4</option><option value=\"5\">5</option>", 5)
const _hoisted_48 = [
  _hoisted_43
]
const _hoisted_49 = { class: "tw-w-full tw-mb-sm" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-md tw-ml-auto",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m16.312 9.76-1.008.992 3.072 3.36H9.24v1.44h9.136l-3.072 3.36 1.008.992 4.592-5.072-4.592-5.072Z",
    fill: "inherit"
  })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.product)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createCommentVNode(" Product Card "),
        _createElementVNode("div", _hoisted_1, [
          _createCommentVNode(" Content & Meta "),
          _createElementVNode("div", _hoisted_2, [
            _createCommentVNode(" Image "),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("a", {
                class: "anchor-none",
                href: _ctx.productUrl,
                "aria-label": `View product: ${_ctx.product.title}`,
                tabindex: "-1"
              }, [
                _createElementVNode("img", {
                  class: "tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-object-cover tw-object-center",
                  src: _ctx.product.featuredImage,
                  alt: _ctx.product.featuredImageAlt
                }, null, 8 /* PROPS */, _hoisted_5)
              ], 8 /* PROPS */, _hoisted_4)
            ]),
            _createCommentVNode(" / Image "),
            _createCommentVNode(" Product Title "),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, [
                _createElementVNode("a", {
                  class: "anchor-none",
                  href: _ctx.productUrl,
                  "aria-label": `View product: ${_ctx.product.title}`,
                  tabindex: "-1"
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.product.title), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_8)
              ]),
              _createCommentVNode(" <template v-if=\"product.farmName\">\n            <div class=\"tw-w-full tw-my-md\">\n              <p class=\"tw-text-base\">{{ product.farmName }}</p>\n            </div>\n          </template> "),
              (_ctx.productPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.productPrice), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" / Product Title "),
            _hoisted_12,
            _createCommentVNode(" Meta Fields "),
            (_ctx.showMetaFields)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                  (_ctx.product.flavourNotes)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("span", _hoisted_16, [
                          (_ctx.flavourProfile)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(`tag tag-reverse ${_ctx.flavourProfile}`)
                              }, _toDisplayString(_ctx.product.flavourNotes), 3 /* TEXT, CLASS */))
                            : _createCommentVNode("v-if", true),
                          (!_ctx.flavourProfile)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.product.flavourNotes), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.product.process)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.product.process), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.product.varietal)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.product.varietal), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" / Meta Fields ")
          ]),
          _createCommentVNode(" / Content & Meta "),
          _createCommentVNode(" Action Buttons "),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              class: "btn btn-primary tw-no-underline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleQuickAdd($event))),
              "aria-label": `Show quick add form for product: ${_ctx.product.title}`
            }, _hoisted_28, 8 /* PROPS */, _hoisted_25),
            _createElementVNode("a", {
              class: "btn btn-secondary tw-no-underline",
              href: _ctx.productUrl,
              "aria-label": `View product: ${_ctx.product.title}`
            }, _hoisted_32, 8 /* PROPS */, _hoisted_29)
          ]),
          _createCommentVNode(" / Action Buttons "),
          _createCommentVNode(" Quick Add Overlay "),
          _createElementVNode("div", {
            class: _normalizeClass(["tw-w-full tw-z-1 tw-px-md md:tw-my-xs tw-pt-xs tw-border tw-border-black tw-bg-white tw-absolute tw-left-0 tw-bottom-0 md:tw-bottom-auto md:tw-top-full tw-shadow-lg", { 'tw-hidden': !_ctx.showQuickAdd }]),
            "data-quick-add-container": ""
          }, [
            _createCommentVNode(" Action Bar "),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("button", {
                class: "p tw-leading-4 tw-mb-xs tw-text-right",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeQuickAdd())),
                "aria-label": "Close Quick Add overlay"
              }, " Close x ")
            ]),
            _createCommentVNode(" / Action Bar "),
            _createCommentVNode(" Variants "),
            (_ctx.product.options)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.options, (option, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(`tw-w-full ${
                _ctx.product.options.length == 1 ? 'tw-col-span-2' : ''
              }`),
                      key: option.name
                    }, [
                      _createElementVNode("label", {
                        for: `Option-${_ctx.product.id}-${index}`,
                        class: "sr-only"
                      }, _toDisplayString(option.name), 9 /* TEXT, PROPS */, _hoisted_36),
                      _withDirectives(_createElementVNode("select", {
                        id: `Option-${_ctx.product.id}-${index}`,
                        "onUpdate:modelValue": ($event: any) => ((option.selectedValue) = $event),
                        onChange: ($event: any) => (_ctx.onOptionChange(_ctx.product, option, $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.values, (value) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: value,
                            value: value
                          }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_38))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_37), [
                        [_vModelSelect, option.selectedValue]
                      ])
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" / Variants "),
            _createCommentVNode(" Finalise Content "),
            _createElementVNode("div", _hoisted_39, [
              _createCommentVNode(" Quantity "),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", {
                  for: `quantity_${_ctx.product.id}`,
                  class: "sr-only"
                }, " Quantity ", 8 /* PROPS */, _hoisted_41),
                _withDirectives(_createElementVNode("select", {
                  type: "number",
                  name: "quantity",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.quantity) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateQuantity && _ctx.updateQuantity(...args))),
                  id: `quantity_${_ctx.product.id}`
                }, _hoisted_48, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_42), [
                  [_vModelSelect, _ctx.quantity]
                ])
              ]),
              _createCommentVNode(" Quantity "),
              _createCommentVNode(" Actions "),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("button", {
                  class: "btn btn-primary tw-justify-start tw-w-full",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addToCart(_ctx.product))),
                  disabled: !_ctx.availableForSale
                }, [
                  (_ctx.availableForSale)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, " Add to cart "))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.availableForSale)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, " Out of Stock "))
                    : _createCommentVNode("v-if", true),
                  _hoisted_53
                ], 8 /* PROPS */, _hoisted_50)
              ]),
              _createCommentVNode(" / Actions ")
            ]),
            _createCommentVNode(" / Finalise Content ")
          ], 2 /* CLASS */),
          _createCommentVNode(" / Quick Add Overlay ")
        ]),
        _createCommentVNode(" / Product Card ")
      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    : _createCommentVNode("v-if", true)
}